var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationDashboardWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 100,
    r: 145,
    stroke: "rgba(255,255,255,0.05)",
    strokeWidth: 44
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 100,
    r: 100,
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 30
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 100,
    r: 63,
    stroke: "rgba(255,255,255,0.09)",
    strokeWidth: 20
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 100,
    r: 38,
    fill: "rgba(255,255,255,0.12)",
    stroke: "rgba(255,255,255,0.30)",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 100,
    r: 29,
    fill: "none",
    stroke: "rgba(255,255,255,0.10)",
    strokeWidth: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 100,
    r: 20,
    fill: "none",
    stroke: "rgba(255,255,255,0.08)",
    strokeWidth: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 100,
    r: 13,
    fill: "rgba(8,16,44,0.65)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 92,
    r: 5,
    fill: "rgba(255,255,255,0.55)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 107,
    r: 2,
    fill: "rgba(255,255,255,0.22)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDashboardWelcome);
export default __webpack_public_path__ + "static/media/illustration-dashboard-welcome.6255dd5b84c170a4ea5f2d3a9cd287e2.svg";
export { ForwardRef as ReactComponent };